import * as React from "react";
import { styled } from "@mui/system";
import { ListItemButton as VaporListtemButton } from "@vapor/react-material/ListItemButton";
import { ListItemButtonProps } from "@mui/material";
import {
  ExtendButtonBase,
  ExtendButtonBaseTypeMap
} from "@mui/material/ButtonBase";

const SublevelListItemButtonRoot = styled(VaporListtemButton, {
  name: "SublevelListItemButton",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  height: 48,
  background: theme.palette.primary.surfaceDefault,
  paddingLeft: "14px",
  "&.MuiListItemButton-root": {
    border: "1px solid transparent",
    "&:hover": {
      border: "1px solid " + theme.palette.primary.interactiveDefault,
      background: theme.palette.primary.surfaceDefault
    },
    "&.Mui-selected": {
      background: theme.palette.primary.interactiveSelectedColor,
      borderLeft: "2px solid " + theme.palette.primary.interactiveDefault
    },
    "&:focus-visible": {
      background: theme.palette.primary.interactiveSelectedColor
    }
  },
  "&.MuiListItemButton-root > .MuiSvgIcon-root": {
    color: theme.palette.primary.iconDefault,
    fontSize: 20
  }
}));

export type ListItemButtonTypeMap<
  AdditionalProps = {},
  RootComponent extends React.ElementType = "div"
> = ExtendButtonBaseTypeMap<{
  props: AdditionalProps & ListItemButtonProps;
  defaultComponent: RootComponent;
}>;

export const SublevelListItemButton = React.forwardRef<
  HTMLDivElement,
  ListItemButtonProps
>(function ListItemButton(props, ref) {
  return <SublevelListItemButtonRoot {...props} ref={ref} />;
}) as ExtendButtonBase<ListItemButtonTypeMap>;
